import { AxiosResponse } from 'axios';

import { Scheduler, SchedulerBody } from '../pages/inventory-control/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessPostUpdateScheduler extends ResponseREST {
	data: Array<Scheduler>;
}

export const postUpdateScheduler = async (
	body: SchedulerBody,
): Promise<ResponseSuccessPostUpdateScheduler> => {
	return axiosInstance
		.post('update-scheduler', body)
		.then((res: AxiosResponse<ResponseSuccessPostUpdateScheduler>) => res.data)
		.catch((err) => err);
};
